var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Component, EventEmitter, Output, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subject } from 'rxjs';
import { NGXLogger } from 'ngx-logger';
import { AuAction } from '../../../../action/au.action';
import { MessageService } from '../../../../service/message.service';
import { PageService } from '../../../../models/page.service';
import { ContentBaseComponent } from '../../../../component/base/contentbase.component';
import { KtsMultiSelectConstructionWorkerService } from './multiselect-construction-worker.service';
import { ValidationService } from '../../../../service/validation.service';
import { AddRowDirective } from '../../../../component/addrow/addrow.directive';
var KtsMultiSelectConstructionWorkerComponent = /** @class */ (function (_super) {
    __extends(KtsMultiSelectConstructionWorkerComponent, _super);
    function KtsMultiSelectConstructionWorkerComponent(router, route, logger, action, message, page, service, validService) {
        var _this = _super.call(this, router, route, logger, action, message, page, service) || this;
        _this.router = router;
        _this.route = route;
        _this.logger = logger;
        _this.action = action;
        _this.message = message;
        _this.page = page;
        _this.service = service;
        _this.validService = validService;
        _this.modalSubmit = new EventEmitter();
        _this.partnerCompanyMap = {}; // 協力会社名マップ（協力会社の全データを保持、名前表示用）
        _this.partnerCompanyRosterMap = {}; // 協力会社名簿マップ（協力会社名簿の全データを保持、名前表示用）
        _this.recs = []; // 協力会社名簿リスト（協力会社名簿の全データを保持）
        _this.items = []; // 右ペインに表示される選択肢の作業員リスト（選択中の協力会社で絞り込まれる）
        _this.select = []; // 左ペインに表示される選択中の作業員リスト
        _this.addRec = {};
        _this.readonly = false;
        _this.dispPartnerCompanyId = 0; // 選択中の協力会社
        _this.dispPartnerCompany = []; // 表示用の作業員名
        _this.partnerCompany = new Subject();
        _this.partnerCompanyRoster = new Subject();
        _this.completeGetList = false; // getList()が完了していない場合(=false)は作業員一覧を非表示にする
        _this.targetPartnerCompanyRoster = []; // 選択中の協力会社に紐づく協力会社名簿IDのリスト
        _this.baseUrl = '/v1/gen/partner-company-roster-api';
        _this.service.init();
        return _this;
    }
    KtsMultiSelectConstructionWorkerComponent.prototype.ngOnInit = function () {
        _super.prototype.ngOnInit.call(this);
        this.subsc = this.service.observable.subscribe();
        this.setCompRec();
    };
    KtsMultiSelectConstructionWorkerComponent.prototype.getList = function () {
        var _this = this;
        this.completeGetList = false;
        this.recs = [];
        var countComplete = 0;
        var predProject = '?query={"predicateList":[{"name":"project_m.id","value":"' + this.projectMId + '","operator":"eq"}]}';
        this.service.setBaseUrl('/v1/gen/project-partner-company-api' + predProject);
        this.service.getRecord().subscribe(function (result) {
            result.items.forEach(function (item) {
                var partnerCompanyMId = item.partner_company_m_id;
                _this.partnerCompany.next(partnerCompanyMId);
                _this.service.setBaseUrl('/v1/gen/partner-company-m-service/' + partnerCompanyMId);
                _this.service.getRecord().subscribe(function (result) {
                    var name = result.name;
                    _this.dispPartnerCompany.push({
                        code: partnerCompanyMId,
                        display: name
                    });
                    _this.partnerCompanyMap[partnerCompanyMId] = name;
                    _this.partnerCompanyRoster.next(partnerCompanyMId);
                });
                var predPartner = '?query={"predicateList":[{"name":"partner_company_m.id","value":"' + partnerCompanyMId + '","operator":"eq"}]}';
                _this.service.setBaseUrl(_this.baseUrl + predPartner);
                _this.service.getRecord().subscribe(function (result) {
                    result.items.forEach(function (result) {
                        var temp = {
                            partner_company_roster_id: result.id,
                            sei: result.sei,
                            mei: result.mei,
                            partner_company_id: result.partner_company_m_id
                        };
                        _this.recs.push(temp);
                        _this.partnerCompanyRosterMap[temp.partner_company_roster_id] = temp;
                    });
                    $(_this.element).multiSelect('refresh');
                }, function () { }, function () {
                    countComplete++;
                    if (countComplete === result.items.length) {
                        _this.completeGetList = true;
                    }
                });
            });
        });
    };
    KtsMultiSelectConstructionWorkerComponent.prototype.getAddCols = function (cols) {
        this.addRec = {};
        for (var _i = 0, cols_1 = cols; _i < cols_1.length; _i++) {
            var col = cols_1[_i];
            if (col.hidden && col.key && col.params && typeof col.params.initValue !== 'undefined') {
                this.addRec[col.key] = col.params.initValue;
            }
        }
    };
    KtsMultiSelectConstructionWorkerComponent.prototype.ngAfterViewInit = function () {
        var _this = this;
        this.modal = this.remodalElement.nativeElement;
        this.remodal = $(this.modal).remodal({ hashTracking: false });
        var self = this;
        this.element = this.multiSelectElement.nativeElement;
        this.select = [];
        $(this.element).multiSelect({
            afterInit: function (ms) {
                var selectableSearchString = '#' + this.$container.attr('id') + ' .ms-elem-selectable:not(.ms-selected)';
                $(selectableSearchString).hide();
                if (self.dispPartnerCompanyId > 0) {
                    $(selectableSearchString + '[data-id="' + self.dispPartnerCompanyId + '"]').show();
                }
                else {
                    $(selectableSearchString).show();
                }
            },
            afterSelect: function (values) {
                if (values && values[0]) {
                    self.select.push(values[0]);
                }
            },
            afterDeselect: function (values) {
                if (values && values[0]) {
                    var idx = self.select.indexOf(values[0]);
                    if (idx >= 0) {
                        self.select.splice(idx, 1);
                    }
                }
                $(self.element).multiSelect('refresh');
            }
        });
        this.multiSelectOptions.changes.subscribe(function (t) {
            $(_this.element).multiSelect('refresh');
        });
    };
    KtsMultiSelectConstructionWorkerComponent.prototype.setUnsubscribe = function () {
        this.changeSubscription.unsubscribe();
    };
    KtsMultiSelectConstructionWorkerComponent.prototype.onSubscribe = function (data) {
        var _this = this;
        this.items = [];
        this.projectMId = data['project_m_id'];
        if (typeof data[this.cols[0].key] !== 'undefined' && data[this.cols[0].key] instanceof Array) {
            var partner_company_roster_ids = data[this.cols[0].key];
            partner_company_roster_ids.forEach(function (partner_company_roster_id) {
                var temp = {
                    $type: "put" /* Put */,
                    partner_company_roster_id: partner_company_roster_id
                };
                if (typeof temp.partner_company_roster_id !== 'undefined') {
                    _this.items.push(temp);
                }
            });
        }
        this.onCancel();
        this.getList();
        this.setCompRec();
    };
    KtsMultiSelectConstructionWorkerComponent.prototype.onModeSubscribe = function (mode) {
        this.readonly = false;
        if (mode === 'confirm' || (this.cols.length > 0 && this.cols[0].readonly)) {
            this.readonly = true;
        }
    };
    KtsMultiSelectConstructionWorkerComponent.prototype.onEventSubscribe = function (e) {
        if (e === this.componentName + '#open') {
            this.onCancel();
            this.remodal.open();
        }
    };
    KtsMultiSelectConstructionWorkerComponent.prototype.onEvent = function (e1, e2, rec) {
    };
    KtsMultiSelectConstructionWorkerComponent.prototype.onCancel = function () {
        $(this.element).multiSelect('deselect_all');
        var select = [];
        for (var _i = 0, _a = this.items; _i < _a.length; _i++) {
            var item = _a[_i];
            if (item.$type !== "delete" /* Delete */) {
                select.push(item.partner_company_roster_id.toString());
            }
        }
        $(this.element).multiSelect('select', select);
        this.select = select;
        this.dispPartnerCompanyId = 0;
        this.targetPartnerCompanyRoster = [];
        $(this.element).multiSelect('refresh');
    };
    KtsMultiSelectConstructionWorkerComponent.prototype.onSubmit = function () {
        this.setItems();
        this.setCompRec();
        this.remodal.close();
        this.dispPartnerCompanyId = 0;
    };
    KtsMultiSelectConstructionWorkerComponent.prototype.setItems = function () {
        var items = JSOG.parse(JSON.stringify(this.items));
        for (var _i = 0, items_1 = items; _i < items_1.length; _i++) {
            var item = items_1[_i];
            item.$type = "delete" /* Delete */;
        }
        var _loop_1 = function (selected_partner_company_roster_id) {
            var selected_rec = this_1.recs.find(function (r) { return r.partner_company_roster_id.toString() === selected_partner_company_roster_id; });
            var add = true;
            for (var _i = 0, items_2 = items; _i < items_2.length; _i++) {
                var item = items_2[_i];
                if (item.partner_company_roster_id === selected_rec.partner_company_roster_id) {
                    add = false;
                    item.$type = "put" /* Put */;
                    break;
                }
            }
            if (add) {
                items.push({
                    $type: "post" /* Post */,
                    partner_company_roster_id: selected_rec.partner_company_roster_id
                });
            }
        };
        var this_1 = this;
        for (var _a = 0, _b = this.select; _a < _b.length; _a++) {
            var selected_partner_company_roster_id = _b[_a];
            _loop_1(selected_partner_company_roster_id);
        }
        this.items = items;
    };
    KtsMultiSelectConstructionWorkerComponent.prototype.setCompRec = function () {
        var data = {};
        var items = JSOG.parse(JSON.stringify(this.items));
        if (Object.keys(this.addRec).length > 0) {
            for (var _i = 0, items_3 = items; _i < items_3.length; _i++) {
                var item = items_3[_i];
                Object.assign(item, this.addRec);
            }
        }
        var partner_company_roster_ids = [];
        for (var _a = 0, items_4 = items; _a < items_4.length; _a++) {
            var item = items_4[_a];
            if (item.$type !== "delete" /* Delete */) {
                partner_company_roster_ids.push(item.partner_company_roster_id);
            }
        }
        data[this.cols[0].key] = partner_company_roster_ids;
        this.action.setCompRec(this.componentName, data);
    };
    KtsMultiSelectConstructionWorkerComponent.prototype.ngOnDestroy = function () {
        _super.prototype.ngOnDestroy.call(this);
        this.subsc.unsubscribe();
        if ($(this.modal).parent().hasClass('remodal-wrapper')) {
            this.remodal.destroy();
        }
    };
    // 協力会社を切り替える
    KtsMultiSelectConstructionWorkerComponent.prototype.onChangeDispPartnerCompany = function (e) {
        var _this = this;
        this.dispPartnerCompanyId = parseInt(e.target.value);
        if (this.dispPartnerCompanyId === 0) {
            this.targetPartnerCompanyRoster = [];
            $(this.element).multiSelect('refresh');
            return;
        }
        this.service.setBaseUrl(this.baseUrl + '?query={"predicateList":[{"name":"partner_company_m.id","value":"' + this.dispPartnerCompanyId + '","operator":"eq"}]}');
        this.service.getRecord().subscribe(function (results) {
            var targets = [];
            for (var _i = 0, _a = results.items; _i < _a.length; _i++) {
                var result = _a[_i];
                targets.push(result.id.toString()); // partner_company_roster.id
            }
            _this.targetPartnerCompanyRoster = targets;
            $(_this.element).multiSelect('refresh');
        });
    };
    KtsMultiSelectConstructionWorkerComponent.decorators = [
        { type: Component, args: [{
                    moduleId: module.id.toString(),
                    selector: 'kts-multiselect-construction-worker',
                    template: "<form id=\"{{ componentName }}\" *ngIf=\"cols?.length > 0\">\n  <div class=\"row\">\n    <div class=\"col-sm-12\">\n      <dl class=\"form\">\n        <dt class=\"form_dt\">\n          <column-formtitle [key]=\"'form'\" [col]=\"cols[0]\" [msg]=\"(msg | async)\"></column-formtitle>\n        </dt>\n      </dl>\n    </div>\n  </div>\n  <div addrowDir></div>\n  <div class=\"row -mt-1\" *ngIf=\"!readonly\">\n    <div class=\"col-sm-12\">\n      <btn\n          [componentName]=\"componentName + '#Button'\"\n          [component]=\"{\n            params: {\n              buttons: [{\n                type: 'button',\n                event: componentName + '#open',\n                caption: (msg | async)['Button_select']\n              }]\n            }\n          }\"></btn>\n    </div>\n  </div>\n  <div class=\"row\" [class.-mt-1]=\"!readonly\">\n    <div class=\"col-sm-12\">\n      <div class=\"tableWrapper\" id=\"{{ componentName + '#List' }}\">\n        <table class=\"tableWrapper_table\">\n          <thead>\n            <tr data-href=\"#\">\n              <th><a class=\"-fixed\">{{ (msg | async)['au.COMPONENT.KtsMultiSelectConstructionWorkerComponent.label.partner_company_name'] }}</a></th>\n              <th><a class=\"-fixed\">{{ (msg | async)['au.COMPONENT.KtsMultiSelectConstructionWorkerComponent.label.construction_worker_name'] }}</a></th>\n            </tr>\n          </thead>\n          <tbody>\n          <ng-template ngFor let-item [ngForOf]=\"items\">\n            <tr *ngIf=\"item.$type !== 'delete' && completeGetList\" data-href=\"#\">\n              <td>\n                <column-formlabel [col]=\"{}\" [val]=\"partnerCompanyMap[partnerCompanyRosterMap[item.partner_company_roster_id].partner_company_id]\"></column-formlabel>\n              </td>\n              <td>\n                <column-formlabel [col]=\"{}\" [val]=\"partnerCompanyRosterMap[item.partner_company_roster_id].sei + ' ' + partnerCompanyRosterMap[item.partner_company_roster_id].mei\"></column-formlabel>\n              </td>\n            </tr>\n          </ng-template>\n          </tbody>\n        </table>\n      </div>\n    </div>\n  </div>\n\n  <!-- remodal -->\n  <div class=\"remodal\" id=\"{{ componentName + '#MultiSelect' }}\" #remodal>\n    <div class=\"remodal_whitebg\">\n      <p *ngIf=\"component.title\" class=\"sectionHeading\">{{ component.title }}</p>\n      <div class=\"ms-container_divisionWrapper\">\n        <p class=\"ms-container_division\">\n          <select (change)=\"onChangeDispPartnerCompany($event)\">\n            <option value=\"0\" [selected]=\"dispPartnerCompanyId === 0\">{{ (msg | async)['au.COMPONENT.KtsMultiSelectConstructionWorkerComponent.select.dispParterCompany'] }}</option>\n            <option *ngFor=\"let option of dispPartnerCompany\" [value]=\"option.code\" [selected]=\"dispPartnerCompanyId.toString() === option.code\">{{ option.display }}</option>\n          </select>\n        </p>\n      </div>\n      <div class=\"ms-containerWrapper\">\n        <select multiple=\"multiple\" #multiSelect>\n          <option *ngFor=\"let rec of recs\" [value]=\"rec.partner_company_roster_id\" [attr.data-id]=\"rec.partner_company_id\" #multiSelectOptions>{{ partnerCompanyMap[rec.partner_company_id] + ' ' + rec.sei + ' ' + rec.mei }}</option>\n        </select>\n      </div>\n    </div>\n    <div class=\"remodal_btns\">\n      <ul class=\"remodal_btns_group\">\n        <li>\n          <button type=\"submit\" class=\"remodal_btns_group-ok\" (click)=\"onSubmit()\">{{ (msg | async)['au.COMPONENTS.modal.button.decide'] }}</button>\n        </li>\n        <li>\n          <button data-remodal-action=\"cancel\" type=\"reset\" class=\"remodal_btns_group-cancel\" (click)=\"onCancel()\">{{ (msg | async)['au.COMPONENTS.modal.button.close'] }}</button>\n        </li>\n      </ul>\n    </div>\n  </div>\n  <!-- /remodal -->\n</form>\n"
                }] }
    ];
    /** @nocollapse */
    KtsMultiSelectConstructionWorkerComponent.ctorParameters = function () { return [
        { type: Router },
        { type: ActivatedRoute },
        { type: NGXLogger },
        { type: AuAction },
        { type: MessageService },
        { type: PageService },
        { type: KtsMultiSelectConstructionWorkerService },
        { type: ValidationService }
    ]; };
    KtsMultiSelectConstructionWorkerComponent.propDecorators = {
        modalSubmit: [{ type: Output }],
        remodalElement: [{ type: ViewChild, args: ['remodal',] }],
        multiSelectElement: [{ type: ViewChild, args: ['multiSelect',] }],
        multiSelectOptions: [{ type: ViewChildren, args: ['multiSelectOptions',] }],
        dir: [{ type: ViewChild, args: [AddRowDirective,] }]
    };
    return KtsMultiSelectConstructionWorkerComponent;
}(ContentBaseComponent));
export { KtsMultiSelectConstructionWorkerComponent };
//# sourceMappingURL=multiselect-construction-worker.component.js.map